import { cn } from "@/lib/utils/cn";
import type { ReactNode } from "react";

type BadgeVariant = "default" | "brand" | "accent" | "success" | "warning" | "destructive" | "muted";
type BadgeSize = "sm" | "md";

interface BadgeProps {
  children: ReactNode;
  variant?: BadgeVariant;
  size?: BadgeSize;
  className?: string;
  dot?: boolean;
}

const variantMap: Record<BadgeVariant, string> = {
  default: "bg-foreground/10 text-foreground",
  brand: "bg-brand-muted text-brand",
  accent: "bg-accent/15 text-accent",
  success: "bg-success/15 text-success",
  warning: "bg-warning/15 text-warning",
  destructive: "bg-destructive/15 text-destructive",
  muted: "bg-muted text-text-muted",
};

const sizeMap: Record<BadgeSize, string> = {
  sm: "text-2xs px-2 py-0.5 gap-1",
  md: "text-xs px-2.5 py-1 gap-1.5",
};

export function Badge({ children, variant = "default", size = "sm", className, dot }: BadgeProps) {
  return (
    <span className={cn(
      "inline-flex items-center font-medium rounded-full",
      variantMap[variant],
      sizeMap[size],
      className
    )}>
      {dot && <span className="w-1.5 h-1.5 rounded-full bg-current" />}
      {children}
    </span>
  );
}
